import React from 'react';
import { graphql, DataValue } from 'react-apollo';
import {
  ListingsCollection,
  ExternalProps as IListingCollectionProps,
} from './components/listings_collection';
import {
  ListingsCollection as ListingsCollectionQuery,
} from './rql';

interface IConfig<Query, Variables, Props> {
  query;
  options: (ownProps: Props) => {};
  extractListings: (data: DataValue<Query, Variables>) => ListingsCollectionQuery.Fragment[];
  shouldRender: (data: DataValue<Query, Variables>, ownProps: Props) => boolean;
  buildDefaultProps: (ownProps: Props) => IListingCollectionProps;
}

function withListings<Query, Variables, Props extends IListingCollectionProps>(config: IConfig<Query, Variables, Props>) {
  const { query, options, extractListings, shouldRender, buildDefaultProps } = config;

  return graphql<Props, Query, Variables>(query, { options })(
    (props) => {
      const { data, ...incomingProps } = props;
      const defaultProps = buildDefaultProps(props);

      if (!shouldRender(data, props)) { return null; }

      const listings = extractListings(data);
      const mergedProps = {
        listings,
        loading: data.loading,
        ...defaultProps,
        ...incomingProps,
      };

      return <ListingsCollection {...mergedProps} />;
    },
  );
}

export default withListings;
